/**
 * PWA install helpers (no service worker logic here).
 */

import { isIosWebKit } from "../../utils/isIosWebKit";

/** @returns {boolean} */
export function isStandaloneDisplay() {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    /** @type {Window & { navigator: Navigator & { standalone?: boolean } }} */ (
      window
    ).navigator.standalone === true
  );
}

/** @returns {boolean} */
export function isIosSafari() {
  return isIosWebKit();
}

const DISMISS_KEY = "shuttlescore_pwa_install_dismissed_at";
const DISMISS_MS = 14 * 24 * 60 * 60 * 1000;

/** @returns {boolean} */
export function isInstallBannerDismissed() {
  try {
    const raw = localStorage.getItem(DISMISS_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return false;
    return Date.now() - ts < DISMISS_MS;
  } catch {
    return false;
  }
}

export function dismissInstallBanner() {
  try {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
  } catch {
    /* storage */
  }
}

export function clearInstallBannerDismissal() {
  try {
    localStorage.removeItem(DISMISS_KEY);
  } catch {
    /* storage */
  }
}

/** @returns {boolean} */
export function isChromiumInstallEnvironment() {
  if (typeof navigator === "undefined") return false;
  if (isIosSafari()) return false;
  return "serviceWorker" in navigator;
}

/**
 * @returns {string}
 */
export function getManifestUrl() {
  const base = process.env.PUBLIC_URL || "";
  return `${base}/manifest.webmanifest`;
}

/**
 * @returns {string}
 */
export function getServiceWorkerUrl() {
  const base = process.env.PUBLIC_URL || "";
  return `${base}/service-worker.js`;
}

/**
 * @returns {string}
 */
export function getServiceWorkerScope() {
  const base = process.env.PUBLIC_URL || "/";
  return base.endsWith("/") ? base : `${base}/`;
}
